import { Component, inject, OnInit } from '@angular/core';
import { CommonService } from '@services/common.service';
import { UserInfo } from '@models/UserInfo';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { AppConstants } from '@constants/app.constant';

@Component({
  selector: 'app-header-title',
  templateUrl: './header-title.component.html',
  styleUrl: './header-title.component.scss',
  standalone:true,
  imports:[
    CommonModule,
    MatMenuModule,
    MatIconModule
  ]
})
export class HeaderTitleComponent implements OnInit {
  commonService=inject(CommonService);
  userInfo!: UserInfo;
  constants = AppConstants;
  ngOnInit(): void {
    this.commonService.getProfileName('user').subscribe((res: UserInfo) => {
      this.userInfo = res;
    });
  }
  onBackClick() {
    this.commonService.bsBackButton.next(this.commonService.navFrom);
  }
  logout() {
    this.commonService.clearSession();
    this.commonService.logOut();
  }
}
